import React, { useState } from "react";
import { Button, CircularProgress, Stack } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import TableChartIcon from "@mui/icons-material/TableChart";
import SummarizeIcon from "@mui/icons-material/Summarize";
import { useTranslation } from "react-i18next";
import {
  exportPlatformDominioPassengerFinancialCsv,
  exportPlatformDominioMercadoPagoReportCsv,
} from "../../../api/passagensApi";

export default function PassengerWorkspaceFinancialExports({ dominioId, from, to }) {
  const { t } = useTranslation("app");
  const [exporting, setExporting] = useState(false);
  const [exportingMp, setExportingMp] = useState(false);

  const rangeParams = { from: from || undefined, to: to || undefined };

  const handleExport = async () => {
    setExporting(true);
    try {
      const blob = await exportPlatformDominioPassengerFinancialCsv(dominioId, rangeParams);
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `passagens-financeiro-${dominioId}.csv`;
      a.click();
      URL.revokeObjectURL(url);
    } catch (err) {
      window.alert(err?.response?.data?.message || err?.message || "Erro ao exportar.");
    } finally {
      setExporting(false);
    }
  };

  const handleExportMpReport = async (format) => {
    setExportingMp(true);
    try {
      const blob = await exportPlatformDominioMercadoPagoReportCsv(dominioId, { ...rangeParams, format });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `mp-relatorio-${format}-${dominioId}.csv`;
      a.click();
      URL.revokeObjectURL(url);
    } catch (err) {
      window.alert(err?.response?.data?.message || err?.message || "Erro ao exportar relatório MP.");
    } finally {
      setExportingMp(false);
    }
  };

  if (!dominioId) return null;

  return (
    <Stack direction={{ xs: "column", sm: "row" }} spacing={1} flexWrap="wrap" useFlexGap>
      <Button size="small" variant="outlined" startIcon={<FileDownloadIcon />} onClick={handleExport} disabled={exporting}>
        {exporting ? <CircularProgress size={16} /> : null}
        {t("platformPage.passengerFinancialExport")}
      </Button>
      <Button
        size="small"
        variant="outlined"
        startIcon={exportingMp ? <CircularProgress size={16} /> : <TableChartIcon />}
        onClick={() => handleExportMpReport("detail")}
        disabled={exportingMp}
      >
        {t("platformPage.passengerMpReportDetail")}
      </Button>
      <Button
        size="small"
        variant="outlined"
        startIcon={exportingMp ? <CircularProgress size={16} /> : <SummarizeIcon />}
        onClick={() => handleExportMpReport("summary")}
        disabled={exportingMp}
      >
        {t("platformPage.passengerMpReportSummary")}
      </Button>
    </Stack>
  );
}
